export const LANGUAGE_TYPE = {
    "en-US": "en-US",
    "zh-CN": "zh-CN",
    "zh-TW": "zh-TW"
}